export const MATCH_SETTINGS_GROUP = 'self-match';
export const DTR_SETTINGS_GROUP = 'dtr';
export const TRAVELCOST_SETTINGS_GROUP = 'exclude-travelcost-calculation';
export const ROSTERSTATE_SETTINGS_GROUP = 'roster-state-settings';
